export const medicalInstrumentsSeed = [
  // 1. Urology - 20 Items
  ...Array.from({ length: 20 }).map((_, i) => {
    const types = [
      'Resectoscope (Active/Passive)', 
      'Cystoscope (0/30/70 Degree)', 
      'Optical Urethrotome', 
      'Lithotrite Punch', 
      'JJ Stent (Double J)', 
      'Foley Catheter (Silicone)', 
      'Working Element (Monopolar/Bipolar)',
      'Bladder Syringe (Evacuator)',
      'Stone Grasping Forceps',
      'Ureteroscope (Semi-Rigid)'
    ];
    const type = types[i % types.length];
    const brands = ['Olympus Compatible', 'Storz Compatible', 'Wolf Compatible', 'Hamim Premium'];
    const brand = brands[i % brands.length];
    return {
      name: `${brand} ${type} - Pro Series U-${i + 101}`,
      description: `Professional grade ${type.toLowerCase()} engineered for precision urological surgery. Features high-definition optics with sapphire glass, ergonomic grip for fatigue-free operation, and universal compatibility with standard light cables and camera systems. Autoclavable at 134°C. International standard quality.`,
      price: 1850 + (i * 15),
      category: 'Urology',
      imageUrl: [
        'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1584362917165-526a968579e8?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?auto=format&fit=crop&w=400&q=70'
      ][i % 4],
      stock: 12 + (i % 15),
      code: `URO-PRO-${1000 + i}`,
      size: `${18 + (i % 5)} Fr`,
      measurement: `${300 + (i % 50)}mm`,
      length: `${30 + (i % 10)}cm`,
      width: `${5 + (i % 5)}mm`,
      material: 'Grade 316L Stainless Steel / Sapphire Glass',
      quality: 'Premium Medical Grade',
      usageTime: 'Unlimited (Autoclavable)',
      usageLimit: 50,
      pricePoint: 1850 + (i * 15) + 200,
      wholesalePrice: 1850 + (i * 15) - 100,
      trendingPrice: 1850 + (i * 15) + 50,
      stars: 4 + (i % 2),
      reviewsCount: 15 + (i % 100)
    };
  }),

  // 2. Laparoscopic - 20 Items
  ...Array.from({ length: 20 }).map((_, i) => {
    const types = [
      'Disposable Trocar (5mm/10mm)', 
      'Maryland Dissector', 
      'Fenestrated Grasper', 
      'Metzenbaum Scissors', 
      'Titanium Clip Applier', 
      'Suction Irrigation Set', 
      'Needle Holder (Left/Right)', 
      'Veress Needle',
      'Fan Retractor', 
      'Bipolar Forceps'
    ];
    const type = types[i % types.length];
    return {
      name: `Advanced Laparoscopic ${type} - L-Series ${i + 201}`,
      description: `High-performance ${type.toLowerCase()} for minimally invasive procedures. Designed with a 360-degree rotating shaft, insulated handle for electrosurgical safety, and modular design for easy cleaning. Exceptional tactile feedback and durability. Meets international CE standards.`,
      price: 950 + (i * 10),
      category: 'Laparoscopic',
      imageUrl: [
        'https://images.unsplash.com/photo-1551076805-e1869033e561?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1579154204601-01588f351e67?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1584515979956-d9f6e5d09982?auto=format&fit=crop&w=400&q=70'
      ][i % 4],
      stock: 30 + (i % 20),
      code: `LAP-ADV-${2000 + i}`,
      size: `${5 + (i % 2) * 5}mm`,
      measurement: `${330 + (i % 20)}mm`,
      length: `${33 + (i % 5)}cm`,
      width: `${5 + (i % 5)}mm`,
      material: 'Medical Grade Stainless Steel / Carbon Fiber Handle',
      quality: 'High Precision Grade',
      usageTime: 'Reusable (Autoclavable)',
      usageLimit: 100,
      pricePoint: 950 + (i * 10) + 150,
      wholesalePrice: 950 + (i * 10) - 50,
      trendingPrice: 950 + (i * 10) + 20,
      stars: 5,
      reviewsCount: 28 + (i % 50)
    };
  }),

  // 3. Gynecology - 20 Items
  ...Array.from({ length: 20 }).map((_, i) => {
    const types = [
      'Cusco Vaginal Speculum', 
      'Hegar Uterine Dilator Set', 
      'Sims Uterine Curette', 
      'Diagnostic Hysteroscope', 
      'Schroeder Tenaculum Forceps', 
      'Tischler Biopsy Punch', 
      'Vulsellum Forceps', 
      'Uterine Sound', 
      'Ovum Forceps', 
      'MVA Kit (Manual Vacuum Aspiration)'
    ];
    const type = types[i % types.length];
    return {
      name: `Premium Gynecology ${type} - G-Series ${i + 301}`,
      description: `Specialized ${type.toLowerCase()} for obstetric and gynecological care. Crafted from high-tensile medical stainless steel with a non-reflective satin finish. Ergonomically optimized for patient safety and clinical efficiency. Fully compatible with modern sterilization protocols.`,
      price: 420 + (i * 7),
      category: 'Gynecology',
      imageUrl: [
        'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1584017911766-d451b3d0e843?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=400&q=70'
      ][i % 4],
      stock: 45 + (i % 25),
      code: `GYN-PREM-${3000 + i}`,
      size: `${20 + (i % 10)}mm`,
      measurement: `${250 + (i % 40)}mm`,
      length: `${25 + (i % 8)}cm`,
      width: `${10 + (i % 10)}mm`,
      material: 'Medical Grade Stainless Steel',
      quality: 'Premium Grade',
      usageTime: 'Reusable',
      usageLimit: 80,
      pricePoint: 420 + (i * 7) + 80,
      wholesalePrice: 420 + (i * 7) - 30,
      trendingPrice: 420 + (i * 7) + 15,
      stars: 4,
      reviewsCount: 35 + (i % 40)
    };
  }),

  // 4. Orthopedic - 20 Items
  ...Array.from({ length: 20 }).map((_, i) => {
    const types = [
      'Cannulated Bone Drill', 
      'Sagittal Oscillating Saw', 
      'DCP Bone Plate (Titanium)', 
      'Cortical Compression Screw', 
      'Stille Osteotome', 
      'Leksell Bone Rongeur', 
      'Putti Bone Rasp', 
      'Gigli Saw Handle', 
      'Bone Reduction Forceps', 
      'Intramedullary Nail'
    ];
    const type = types[i % types.length];
    return {
      name: `Heavy-Duty Orthopedic ${type} - O-Series ${i + 401}`,
      description: `Rugged ${type.toLowerCase()} designed for trauma and orthopedic reconstruction. Features high-torque capability, precision cutting edges, and biocompatible materials (Titanium Grade 5 or 316L Stainless Steel). Engineered for long-term reliability in demanding surgical environments.`,
      price: 2450 + (i * 30),
      category: 'Orthopedic',
      imageUrl: [
        'https://images.unsplash.com/photo-1530497610245-94d3c16cda28?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1576091160550-217359f4ecf8?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1583912267670-6575ad362e3b?auto=format&fit=crop&w=400&q=70'
      ][i % 4],
      stock: 15 + (i % 10),
      code: `ORT-HD-${4000 + i}`,
      size: `${3.5 + (i % 5) * 0.5}mm`,
      measurement: `${150 + (i % 100)}mm`,
      length: `${15 + (i % 15)}cm`,
      width: `${12 + (i % 8)}mm`,
      material: 'Titanium Ti6Al4V ELI / 316L VM Stainless Steel',
      quality: 'High-Strength Medical Grade',
      usageTime: 'Variable (Implant/Reusable)',
      usageLimit: 1,
      pricePoint: 2450 + (i * 30) + 400,
      wholesalePrice: 2450 + (i * 30) - 150,
      trendingPrice: 2450 + (i * 30) + 100,
      stars: 5,
      reviewsCount: 12 + (i % 30)
    };
  }),

  // 5. General Surgery - 20 Items
  ...Array.from({ length: 20 }).map((_, i) => {
    const types = [
      'Mayo Surgical Scissor', 
      'Mosquito Hemostatic Forceps', 
      'Mayo-Hegar Needle Holder', 
      'Langenbeck Retractor', 
      'B.P. Scalpel Handle No. 4', 
      'Backhaus Towel Clamp', 
      'Allis Tissue Forceps', 
      'Adson Dressing Forceps', 
      'Senn Retractor', 
      'Iris Fine Scissors'
    ];
    const type = types[i % types.length];
    return {
      name: `Elite General ${type} - S-Series ${i + 501}`,
      description: `Essential ${type.toLowerCase()} for a wide range of general surgical applications. Features precision-aligned tips, smooth box-joint movement, and a balanced weight distribution. Manufactured to exceed international quality standards for durability and performance.`,
      price: 180 + (i * 4),
      category: 'General Surgery',
      imageUrl: [
        'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1584362917165-526a968579e8?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1551076805-e1869033e561?auto=format&fit=crop&w=400&q=70'
      ][i % 4],
      stock: 120 + (i % 60),
      code: `GEN-ELITE-${5000 + i}`,
      size: 'Standard Adult',
      measurement: `${140 + (i % 60)}mm`,
      length: `${14 + (i % 6)}cm`,
      width: `${2 + (i % 4)}mm`,
      material: 'AISI 420 Stainless Steel',
      quality: 'Standard Operating Grade',
      usageTime: 'Reusable',
      usageLimit: 150,
      pricePoint: 180 + (i * 4) + 40,
      wholesalePrice: 180 + (i * 4) - 15,
      trendingPrice: 180 + (i * 4) + 5,
      stars: 4,
      reviewsCount: 85 + (i % 100)
    };
  }),

  // 6. Electrosurgical - 20 Items
  ...Array.from({ length: 20 }).map((_, i) => {
    const types = [
      'Bipolar Coagulation Forceps',
      'Monopolar Electrosurgical Pencil',
      'L-Hook Electrode (Insulated)',
      'Needle Electrode (Ultra-Fine)',
      'Ball Coagulator Electrode',
      'Patient Return Plate Cable',
      'Smoke Evacuation Handpiece',
      'Bipolar Bayonet Forceps',
      'Tungsten Micro-Dissection Needle',
      'High-Frequency Monopolar Cord'
    ];
    const type = types[i % types.length];
    return {
      name: `Pro Electrosurgical ${type} - ES-${i + 601}`,
      description: `State-of-the-art electrosurgical ${type.toLowerCase()} engineered with dual-dielectric silicone insulation, non-stick alloy tips, and universal compatibility with ERBE, Valleylab, and Bowa generators. Autoclavable at 134°C.`,
      price: 340 + (i * 8),
      category: 'Electrosurgical',
      imageUrl: [
        'https://images.unsplash.com/photo-1581093458791-9f3c3250bb8b?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&w=400&q=70',
        'https://images.unsplash.com/photo-1584362917165-526a968579e8?auto=format&fit=crop&w=400&q=70'
      ][i % 4],
      stock: 40 + (i % 20),
      code: `ES-PRO-${6000 + i}`,
      size: `${18 + (i % 4)}cm`,
      measurement: `${180 + (i % 30)}mm`,
      length: `${18 + (i % 5)}cm`,
      width: `${2 + (i % 2)}mm`,
      material: 'German High-Insulation Polymer / Non-Stick Alloy',
      quality: 'Premium Electrosurgical Grade',
      usageTime: 'Reusable (Autoclavable)',
      usageLimit: 120,
      pricePoint: 340 + (i * 8) + 60,
      wholesalePrice: 340 + (i * 8) - 25,
      trendingPrice: 340 + (i * 8) + 15,
      stars: 5,
      reviewsCount: 22 + (i % 30)
    };
  })
];
